// ─── Content Management Endpoints ────────────────────────────────────────────

// Content Pages
export const API_GET_CONTENT_PAGES_URL = '/admin/contents/';
export const API_EDIT_CONTENT_PAGE = '/admin/contents/update';
export const API_GET_CONTENT_PAGE_BY_ID = '/admin/contents/edit/';

// FAQ
export const API_GET_ALL_FAQ = '/admin/getAllFaqs/';
export const API_ADD_FAQ = '/admin/addFaq/';
export const API_EDIT_FAQ = '/admin/editFaq/';
export const API_GET_FAQ = '/admin/getFaqsById/';
export const API_DELETE_FAQ = '/admin/deleteFaq/';

// Advertisements
export const API_ADD_ADVERTISEMENT = '/admin/addAdds';
export const API_GET_ALL_ADVERTISEMENT = '/admin/getAllAdds/';
export const API_EDIT_ADVERTISEMENT = '/admin/editAdds';
export const API_DELETE_ADVERTISEMENT = '/admin/deleteAdds';
export const API_GET_ID_ADVERTISEMENT = '/admin/getAdds/';

// Banners
export const API_ADD_BANNER = '/admin/addBanner';
export const API_GET_ALL_BANNER = '/admin/getAllBanner/';
export const API_EDIT_BANNER = '/admin/editBanner';
export const API_DELETE_BANNER = '/admin/deleteBanner';
export const API_GET_ID_BANNER = '/admin/getBanner/';
